import { api } from '../../DefaultService';
import {
  IEscolarManagerCreateProps,
  IEscolarManagerProps,
  IEscolarManagerUpdateParams,
} from './types';

const ENDPOINT = '/v1/integrations/escolar-manager';

export const createEscolarManagerIntegrationAsync = async (
  data: IEscolarManagerCreateProps,
) => {
  return await api
    .post(`${ENDPOINT}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllEscolarManagerIntegrationsAsync = async (): Promise<
  IEscolarManagerProps[]
> => {
  return await api
    .get<IEscolarManagerProps[]>(`${ENDPOINT}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getEscolarManagerIntegrationByIdAsync = async (
  id: number,
): Promise<IEscolarManagerProps> => {
  return await api
    .get<IEscolarManagerProps>(`${ENDPOINT}/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const updateEscolarManagerIntegrationAsync = async ({
  id,
  data,
}: IEscolarManagerUpdateParams) => {
  return await api
    .put(`${ENDPOINT}/${id}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const deleteEscolarManagerIntegrationAsync = async (id: number) => {
  return await api.delete(`${ENDPOINT}/${id}`).catch((error) => {
    throw new Error(
      error?.response?.data?.message || 'Erro interno do servidor!',
    );
  });
};
